import { Action, createReducer, on } from "@ngrx/store";
import { SoundProfileAction } from "./sound-profile.action";

export const STORE_FEATURE_KEY_SOUND_PROFILE = "soundProfile";

export interface SoundProfileState {
  loading: boolean;
  soundProfile: any;
  parentProfiles: Array<any>;
  scannedSoundProfile: any;
}

export const initializeSoundProfileState: SoundProfileState = {
  loading: false,
  soundProfile: {},
  parentProfiles: [],
  scannedSoundProfile:{},

};

const reducer = createReducer(
  initializeSoundProfileState,
  on(SoundProfileAction.getSoundProfile, (state, payload) => ({
    ...state,
    soundProfile: {},
    loading: true,
  })),
  on(SoundProfileAction.getSoundProfileSuccess, (state, { soundProfile }) => ({
    ...state,
    soundProfile,
    loading: false,
  })),
  on(SoundProfileAction.getSoundProfileFail, (state, payload) => ({
    ...state,
    loading: false,
  })),
  on(SoundProfileAction.getParentProfiles, (state, payload) => ({
    ...state,
    parentProfiles: [],
    loading: true,
  })),
  on(
    SoundProfileAction.getParentProfilesSuccess,
    (state, { parentProfiles }) => ({
      ...state,
      parentProfiles,
      soundProfile: {},
      loading: false,
    })
  ),
  on(SoundProfileAction.scanAr2VoiceTemplate, (state, payload) => ({
    ...state,
    loading: true,
  })),
  on(SoundProfileAction.scanAr2VoiceTemplateSuccess, (state, { scannedSoundProfile }) => ({
    ...state,
    scannedSoundProfile: scannedSoundProfile,
    loading: false,
  })),
  on(SoundProfileAction.scanAr2VoiceTemplateFail, (state, payload) => ({
    ...state,
    loading: false,
  }))
);

export function SoundProfileReducer(
  state: SoundProfileState | undefined,
  action: Action
): SoundProfileState {
  return reducer(state, action);
}
